    <section class="header-btn-wrapper">
        <button type="button" nz-button nzType="primary" (click)="showItem()"><i class="fas fa-fw fa-plus"></i> Create Reward</button>
      </section>
    <ag-grid-angular
    #agGrid
    domLayout='autoHeight'
    class="ag-theme-alpine"
    [rowHeight]="80"
    [rowData]="rewards"
    [columnDefs]="columnDefs"
    rowSelection="multiple"
    [defaultColDef]="defaultColDef"
    [pagination]="true"
    [suppressRowClickSelection]="true"
    (gridReady)="onGridReady($event)"
    [enableCellTextSelection]="true"

  >
  </ag-grid-angular>
  
  